module.exports = __webpack_public_path__ + "img/0S6A0022.fc410558.jpg";